import BaseService from '@/api/services/index'

export interface ExportLogItem {
    id: number;
    createdAt: string;
    entityType: string;
    entityId: string;
    severity: string;
    description: string;
    parameterId: string | null;
    message: string | null;
    runId: string | null;
    partNumber: number | null;
    attempt: number | null;
    batchStatus: string | null;
    runStatus: string | null;
}

export interface ExportLogPageResponse {
    items: ExportLogItem[];
    total: number;
    totalPages: number;
}

export interface ExportLogQueryParams {
    page?: number | string;
    pageSize?: number | string;
    sort?: string;
    entityType?: string;
    severity?: string;
    dateFrom?: string;
    dateTo?: string;
    search?: string;
}

export default class ExportLogService extends BaseService {
    public async getPage (accountId: number|undefined, campaignId: number, query: ExportLogQueryParams): Promise<ExportLogPageResponse> {
        return this.api.get<ExportLogQueryParams, ExportLogPageResponse>(
            this.getUrl('account_campaign_export_log_list', { accountId, campaignId }),
            query
        )
    }
}
